<template>
    <div class="cashout-sectionFour-main">
        <div class="cashout-sectionFour-main__title">
            <strong>Cash Out Details</strong>
        </div>
        <div class="cashout-sectionFour-main__description">
            Please fill in the form below the desired amount to proceed with the
            transaction
        </div>
        <div class="cashout-sectionFour-main__subtitle">Coyn Exchange Rate</div>

        <form id="form" method="POST" @submit.prevent.stop="requestCashback">
            <div class="cashout-sectionFour-main-form__wrapper">
                <div class="cashout-sectionFour-main-form__flexRowOne">
                    <div class="desc">
                        Coyns to exchange:
                    </div>
                    <div class="amount-arrows-conversion">
                        <div class="amount">
                            <div class="text">From:</div>
                            <input
                                v-model.number="
                                    $v.cashbackRequest.currencyAmount.$model
                                "
                                class="input-currency"
                                type="number"
                                :class="
                                    minRequired === null
                                        ? 'neutral'
                                        : minRequired === false
                                        ? 'red'
                                        : 'green'
                                "
                                name="currencyAmount"
                                placeholder="Currency Amount"
                                @input="getMinAmount"
                            />
                            <div v-if="minRequired === false" class="error">
                                Cashback currency amount doesn't meet the
                                minimum required
                            </div>
                        </div>
                        <div class="arrows">
                            <arrow-one />
                            <arrow-two />
                        </div>
                        <div class="conversion-currency">
                            <div>To:</div>
                            <div class="flag-currency-cont">
                                <img
                                    src="~Images/request_cashback/flag.png"
                                    class="flag"
                                />
                                <div class="currency-detail">
                                    <div class="usd">USD</div>
                                    <div class="usdCurr">US Dollar</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cashout-sectionFour-main-form__flexRowTwo">
                    <p>
                        {{ cashbackRequest.currencyAmount }} coyns = <br /><span
                            >${{ exchangeAmount.toFixed(0) }}</span
                        >
                    </p>
                </div>

                <div class="cashout-sectionFour-main-form__flexRowThree">
                    1 coyn = {{ exchangeRate }} USD
                </div>
                <div class="cashout-sectionFour-main-form__flexRowFour">
                    <div class="text">
                        <strong>Coyns</strong> to
                        <strong>US Dollar</strong> Conversion
                    </div>
                    <div class="last-updated">
                        Last updated: 2020-08-20 12:57 UTC
                    </div>
                </div>
            </div>

            <div class="cashout-sectionFour-main-form__flexRowFive">
                Additional Details
            </div>

            <div class="cashout-sectionFour-main-form__wrapperTwo">
                <div class="iban-input-group">
                    <div class="iban-title">IBAN Code / SWIFT</div>

                    <div class="inc-error">
                        <input
                            v-model="$v.cashbackRequest.bankAccountInfo.$model"
                            name="iban"
                            type="text"
                            placeholder="e.g. IBAX-500-xxx"
                            class="iban-input"
                            :class="
                                ibanValidate === null
                                    ? 'neutral'
                                    : ibanValidate === false
                                    ? 'red'
                                    : 'green'
                            "
                            @input="validateIban"
                        />
                        <div v-if="ibanValidate === false" class="error">
                            Please enter a valid IBAN or SWIFT.
                        </div>
                    </div>
                </div>
                <div class="email-input-group">
                    <div class="email-title">E-mail Address</div>
                    <div class="inc-error">
                        <input
                            v-model="$v.cashbackRequest.email.$model"
                            class="email-input"
                            :class="
                                invalidEmail === null
                                    ? 'neutral'
                                    : invalidEmail === true
                                    ? 'red'
                                    : 'green'
                            "
                            type="text"
                            name="email"
                            placeholder="johndoe@email.com"
                            @input="validateEmail"
                        />
                        <div v-if="invalidEmail === true" class="error">
                            Please enter a valid email.
                        </div>
                    </div>
                </div>

                <div class="terms-checkbox">
                    <input
                        id="terms"
                        v-model="$v.cashbackRequest.terms.$model"
                        type="checkbox"
                        value="terms"
                        class="checkbox"
                    />
                    <label for="terms" class="checkbox-label"
                        >I have read and understood all
                        <span class="cash-out-word">Cash Out Terms</span></label
                    >
                    <div
                        v-if="$v.cashbackRequest.terms.$model === false"
                        class="error"
                    >
                        You need acknowledge that you have read and understood
                        all Cash Out terms.
                    </div>
                </div>
                <div class="submit-your-request">
                    <div class="submit-title">Submit your Request</div>
                    <div class="inc-error">
                        <div class="exc-error">
                            <div class="submit-desc">
                                Review and save your profile information.
                            </div>
                            <submit-button
                                class="mr-0"
                                :style="'$button-width'"
                                :submit-button="true"
                            >
                                Proceed
                            </submit-button>
                        </div>
                        <div
                            v-if="
                                submitClicked === 'submit clicked' &&
                                    !formTouched
                            "
                            class="error"
                        >
                            Can't submit an empty form.
                        </div>
                        <div
                            v-if="
                                submitClicked === 'submit clicked' &&
                                    incompleteForm
                            "
                            class="error"
                        >
                            Complete the missing fields.
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import ArrowOne from 'Svgs/arrow_1.svg?inline';
import ArrowTwo from 'Svgs/arrow_2.svg?inline';
import { isValidIBANNumber, isValidSWIFT } from './validators';
import { required, email, minLength } from 'vuelidate/lib/validators';
import CashBack from '../../../services/cashback';
import { mapGetters, mapActions } from 'vuex';
import { MY_OVERVIEW_PAGE_NAME } from '@/router/pageNameConstants.js';
import Btn from '@/components/common/Button';

import {
    addErrorNotification,
    addSuccesNotification,
} from '@/lib/notifications';

export default {
    name: 'RequestCashbackForm',
    components: {
        ArrowOne,
        ArrowTwo,
        'submit-button': Btn,
    },
    props: {
        exchangeRate: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            cashbackRequest: {
                currencyAmount: 0,
                bankAccountInfo: null,
                expectedUsdCents: 0,
                email: '',
                terms: null,
            },

            submitClicked: 'Submit not Clicked',
            incompleteForm: null,
            ibanValidate: null,
            invalidEmail: null,
            isNotValidClass: false,
            minRequired: null,
            formTouched: null,
        };
    },

    computed: {
        exchangeAmount() {
            let exchangedAmount =
                this.cashbackRequest.currencyAmount * this.exchangeRate;

            this.getCurrencyAmount(exchangedAmount);
            return exchangedAmount;
        },
        ...mapGetters('cashback', ['getCashbackSettings']),
    },

    validations: {
        cashbackRequest: {
            currencyAmount: {
                required,
                minLength: minLength(1),
            },
            bankAccountInfo: {
                required,
                ibanOrSwift(bankAccountInfo) {
                    if (
                        isValidIBANNumber(bankAccountInfo) &&
                        !isValidSWIFT(bankAccountInfo)
                    ) {
                        return true;
                    } else if (
                        !isValidIBANNumber(bankAccountInfo) &&
                        isValidSWIFT(bankAccountInfo)
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                },
            },
            terms: { required },
            email: { required, email },
        },
    },

    methods: {
        ...mapActions('recentEarnings', ['fetchRecentEarnings']),
        validateIban() {
            if (
                !this.$v.cashbackRequest.bankAccountInfo.ibanOrSwift &&
                this.$v.cashbackRequest.bankAccountInfo.$model.length > 0
            ) {
                this.ibanValidate = false;
            } else if (this.$v.cashbackRequest.bankAccountInfo.ibanOrSwift) {
                this.ibanValidate = true;
            } else this.ibanValidate = null;
        },
        validateEmail() {
            if (
                this.$v.cashbackRequest.email.$invalid === true &&
                this.$v.cashbackRequest.email.$model.length > 0
            ) {
                this.invalidEmail = true;
            } else if (
                this.$v.cashbackRequest.email.$invalid === false &&
                this.$v.cashbackRequest.email.$model.length > 0
            ) {
                this.invalidEmail = false;
            } else this.invalidEmail = null;
        },
        getMinAmount() {
            if (this.$v.cashbackRequest.currencyAmount.$error === false) {
                if (
                    this.$v.cashbackRequest.currencyAmount.$model <
                    this.getCashbackSettings.minCoynsAmount
                ) {
                    this.minRequired = false;
                } else this.minRequired = true;
            } else this.minRequired = null;
        },
        async requestCashback() {
            if (
                !this.$v.cashbackRequest.bankAccountInfo.$anyDirty &&
                !this.$v.cashbackRequest.currencyAmount.$anyDirty &&
                !this.$v.cashbackRequest.email.$anyDirty &&
                !this.$v.cashbackRequest.terms.$anyDirty
            ) {
                this.formTouched = false;
            } else this.formTouched = true;

            if (this.$v.cashbackRequest.$dirty) {
                this.incompleteForm = false;
            } else if (this.$v.cashbackRequest.$anyDirty && this.formTouched) {
                this.incompleteForm = true;
            }

            this.submitClicked = 'submit clicked';

            if (
                this.formTouched &&
                !this.incompleteForm &&
                !this.$v.$anyError
            ) {
                this.submitClicked = 'form submitted';

                let cashbackPostRequest = {
                    currencyAmount: this.cashbackRequest.currencyAmount,
                    bankAccountInfo: this.cashbackRequest.bankAccountInfo,
                    expectedUsdCents:
                        this.cashbackRequest.expectedUsdCents * 100,
                };
                try {
                    this.$v.cashbackRequest.$reset();
                    await CashBack.requestCashback(cashbackPostRequest);
                    this.$router.push({ name: MY_OVERVIEW_PAGE_NAME });
                    addSuccesNotification(
                        'Coyn commision successfully requested!'
                    );
                } catch (err) {
                    this.$router.push({ name: MY_OVERVIEW_PAGE_NAME });
                    addErrorNotification(
                        'Coyn commision request was not successful'
                    );

                    this.error = true;
                }
            }
        },
        getCurrencyAmount(exchangedAmount) {
            this.cashbackRequest.expectedUsdCents = exchangedAmount.toFixed(0);
        },
    },
};
</script>
<style scoped lang="scss">
.cashout-sectionFour-main {
    display: grid;
    height: fit-content;
    margin-bottom: 10%;

    @media (max-width: $sm-up) {
        padding: 0 5%;
    }

    &__title {
        grid-row-start: 1;
        grid-column: 1 / 2;
        font-size: 35px;
        font-weight: 700;
        letter-spacing: 0.55px;
        line-height: 53px;
        font-family: $politica-font;
        color: $blue-main;

        @media (max-width: $xs-up) {
            text-align: center;
        }
    }

    &__description {
        @include genericRequestCashbackText();
        grid-row-start: 2;
        grid-column: 1 / 2;

        @media (max-width: $xs-up) {
            text-align: center;
        }
    }

    &__subtitle {
        @include titleRequestCashbackText();
        grid-row-start: 3;
        grid-column: 1 / 2;
        padding-top: 5%;

        @media (max-width: $xs-up) {
            text-align: center;
        }
    }

    .cashout-sectionFour-main-form {
        grid-row-start: 4;
        grid-column: 1 / 2;
        display: flex;
        flex-direction: column;

        &__wrapper {
            border-radius: 6px;
            background: rgba(244, 245, 246, 0.6);
            padding: 5% 4%;
        }

        &__flexRowOne {
            display: flex;
            flex-direction: row;

            @media (max-width: $xs-up) {
                flex-direction: column;
            }

            .desc {
                @include biggerText;
                align-self: center;
                flex: 1;
            }

            .amount-arrows-conversion {
                display: flex;
                flex: 3;

                @media (max-width: $xs-up) {
                    flex-direction: column;
                }

                .amount {
                    display: flex;
                    flex-direction: column;
                    border-radius: 6px;
                    padding: 0;
                    flex-basis: 35%;

                    .neutral,
                    input {
                        background: transparent;
                        border: 1px solid #d1d3d5;
                        outline: 0;
                    }
                    .green,
                    input {
                        border: 2px solid #19b767;
                        background: #e4ffe0;
                        outline: 0;
                    }

                    .red,
                    input {
                        background: #ffefeb;
                        border: 2px solid #f8451d;
                        outline: 0;
                    }

                    input {
                        border-radius: 6px;
                        border: 1px solid #d1d3d5;
                        height: 54px;
                        font-family: $palanquin-font;
                    }
                }

                .arrows {
                    display: flex;
                    flex-direction: column;
                    padding: 0 1% 0 1%;
                    align-self: center;
                }

                .conversion-currency {
                    display: flex;
                    flex-direction: column;
                    padding: 0;
                    flex-basis: 40%;

                    .flag-currency-cont {
                        display: flex;
                        background-color: rgba(220, 227, 233, 0.5);
                        border-radius: 6px;
                        height: 54px;

                        .flag {
                            align-self: center;
                        }

                        .currency-detail {
                            display: flex;
                            flex-direction: column;
                            padding-left: 3%;
                            align-self: center;

                            .usd {
                                font-family: $istok-font;
                                font-size: 22px;
                                font-weight: 400;
                                letter-spacing: 0.18px;
                                line-height: 20px;
                                font-family: $istok-font;
                                color: $blue-main;
                            }

                            .usdCurr {
                                font-family: $istok-font;
                                font-size: 12px;
                                font-weight: 400;
                                letter-spacing: 0.18px;
                                line-height: 20px;
                                color: $blue-main;
                            }
                        }
                    }
                }
            }
        }
        &__flexRowTwo {
            @include biggerText;
            display: flex;
            text-align: center;
            padding: 2% 0;

            p {
                margin: auto;

                span {
                    font-family: $istok-font;
                    font-size: 80px;
                    font-weight: 700;
                    letter-spacing: 3px;
                    line-height: 100px;
                }
            }
        }
        &__flexRowThree {
            text-align: center;
            font-family: $istok-font;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0.12px;
            line-height: 30px;
        }

        &__flexRowFour {
            display: flex;
            justify-content: space-between;

            @media (max-width: $xs-up) {
                flex-direction: column;

                .text {
                    text-align: center;
                    padding: 1%;
                }
                .last-updated {
                    text-align: center;
                    padding: 1%;
                }
            }
        }

        &__flexRowFive {
            @include titleRequestCashbackText();
            padding-top: 5%;

            @media (max-width: $xs-up) {
                text-align: center;
                padding: 5%;
            }
        }

        &__wrapperTwo {
            border-radius: 6px;
            background: rgba(244, 245, 246, 0.6);
            padding: 5%;

            .iban-input-group {
                display: flex;

                @media (max-width: $xs-up) {
                    flex-direction: column;
                }

                .iban-title {
                    @include biggerText;
                    align-self: center;
                    flex: 1;

                    @media (max-width: $xs-up) {
                        align-self: unset;
                    }
                }

                .inc-error {
                    display: flex;
                    flex-direction: column;
                    flex: 2;
                }

                .iban-input {
                    height: 54px;
                    border-radius: 6px;
                    border: 1px solid #d1d3d5;
                    input {
                        font-family: $palanquin-font;
                        height: 54px;
                        border-radius: 6px;
                    }
                }
                .neutral,
                input {
                    background: transparent;
                    border: 1px solid #d1d3d5;
                    outline: 0;
                }
                .green,
                input {
                    border: 2px solid #19b767;
                    background: #e4ffe0;
                    outline: 0;
                }

                .red,
                input {
                    background: #ffefeb;
                    border: 2px solid #f8451d;
                    outline: 0;
                }
            }
            .email-input-group {
                display: flex;
                margin-top: 5%;
                margin-bottom: 3%;

                @media (max-width: $xs-up) {
                    flex-direction: column;
                    margin-bottom: 5%;
                }

                .email-title {
                    @include biggerText;
                    align-self: center;
                    flex: 1;

                    @media (max-width: $xs-up) {
                        align-self: unset;
                    }
                }

                .inc-error {
                    flex: 2;
                    display: flex;
                    flex-direction: column;
                }

                .neutral,
                input {
                    background: transparent;
                    border: 1px solid #d1d3d5;
                    outline: 0;
                }
                .green,
                input {
                    border: 2px solid #19b767;
                    background: #e4ffe0;
                    outline: 0;
                }

                .red,
                input {
                    background: #ffefeb;
                    border: 2px solid #f8451d;
                    outline: 0;
                }

                .email-input {
                    height: 54px;
                    border-radius: 6px;

                    input {
                        font-family: $palanquin-font;
                        height: 54px;
                        border-radius: 6px;
                    }
                }
            }

            .terms-checkbox {
                @include genericRequestCashbackText();
                display: inline;
                padding-top: 2%;

                .cash-out-word {
                    text-decoration: underline;
                }

                input[type='checkbox'] {
                    width: auto;
                    opacity: 0.00000001;
                    position: absolute;
                    left: 0;
                    margin-left: -20px;
                }
                label {
                    position: relative;
                }
                label:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    margin: 4px;
                    width: 22px;
                    height: 22px;
                    transition: transform 0.28s ease;
                    border-radius: 3px;
                    // border: 2px solid #7bbe72;
                    border: 2px solid grey;
                }
                label:after {
                    content: '';
                    display: block;
                    width: 10px;
                    height: 5px;
                    border-bottom: 2px solid #7bbe72;
                    border-left: 2px solid #7bbe72;
                    -webkit-transform: rotate(-45deg) scale(0);
                    transform: rotate(-45deg) scale(0);
                    transition: transform ease 0.25s;
                    will-change: transform;
                    position: absolute;
                    top: 12px;
                    left: 10px;
                }
                input[type='checkbox']:checked ~ label::before {
                    color: #7bbe72;
                    border: 2px solid #7bbe72;
                    background: #e4ffe0;
                }

                input[type='checkbox']:checked ~ label::after {
                    -webkit-transform: rotate(-45deg) scale(1);
                    transform: rotate(-45deg) scale(1);
                }

                label {
                    min-height: 34px;
                    display: block;
                    padding-left: 40px;
                    margin-bottom: 0;
                    font-weight: normal;
                    cursor: pointer;
                    vertical-align: sub;
                }
                .checkbox label span {
                    position: absolute;
                    top: 50%;
                    -webkit-transform: translateY(-50%);
                    transform: translateY(-50%);
                }
                .checkbox input[type='checkbox']:focus + label::before {
                    outline: 0;
                }

                .checkbox {
                    margin-right: 2%;
                }

                .checkbox-label {
                    flex: 2;
                }
            }

            .submit-your-request {
                margin-top: 4%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 6px;
                border: 1px solid #0a294a;
                padding: 4%;

                @media (max-width: $xs-up) {
                    flex-direction: column;
                    text-align: center;
                }

                .submit-title {
                    @include titleRequestCashbackText();
                    flex-basis: 40%;
                }

                .exc-error {
                    display: flex;
                    flex-basis: 70%;
                    justify-content: space-between;
                }
                .inc-error {
                    display: flex;
                    flex-direction: column;
                    flex-basis: 70%;
                    justify-content: space-between;
                }

                .submit-desc {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    font-family: $istok-font;
                    color: $blue-main;
                    align-self: center;
                }
            }
        }
    }

    .error {
        color: #c32121;
        font-size: 14px;
        padding: 1% 0;
    }
}
</style>
